import { getState } from '~src/state';
import { displayBackgroundManager } from '~src/sidebar/index';

export const addImageFormatToCache = (backgroundItemId, formatsId) => {
  const currentFormat = getState('sidebarCurrentBackgroundFormat', 'NO_TAG');
  const backgroundItem = window.editorConfig.sidebarBackgrounds[
    currentFormat
  ].items.find((item) => item.objectId === backgroundItemId);

  if (formatsId) {
    formatsId.forEach((id) => {
      const formatItem = window.editorConfig.defaultFormats.items.find(
        (item) => item.objectId === id
      );
      backgroundItem.formats.push(formatItem);
    });
  }
  displayBackgroundManager(backgroundItemId);
};
